$(document).ready(function () {
  $('.form_signup_input.firstname').keyup(function() {
    let firstname = $(this).val();
    let errorMessage = $(this).closest('.form_signup_container ').find('.error-message');
    if (firstname === '') {
      errorMessage.show();
      $(this).addClass('validate-error')
      errorMessage.text('氏名が入力されていません。')
    } else {
      $(this).removeClass('validate-error')
      if (!$(".form_signup_input.lastname").hasClass('validate-error')) {
        errorMessage.hide();
      }
    }
  });

  $('.form_signup_input.lastname').keyup(function() {
    let lastName = $(this).val();
    let errorMessage = $(this).closest('.form_signup_container ').find('.error-message');
    if (lastName === '') {
        errorMessage.show();
        $(this).addClass('validate-error')
        errorMessage.text('氏名が入力されていません。')
    } else {
      $(this).removeClass('validate-error')
      if (!$(".form_signup_input.firstname").hasClass('validate-error')) {
        errorMessage.hide();
      }
    }
  });

  $('.form_signup_input.firstname_kata').keyup(function() {
    let firstname = $(this).val();
    let errorMessage = $(this).closest('.form_signup_container ').find('.error-message');
    if (firstname === '') {
      errorMessage.show();
      $(this).addClass('validate-error')
      errorMessage.text('ヨミガナが入力されていません。')
    } else {
      var katakanaRegex = /^[\u30A0-\u30FF]+$/;
      if (!katakanaRegex.test(firstname)) {
        errorMessage.show();
        errorMessage.text('正しくヨミガナを入力してください。')
        if (!$(this).hasClass('validate-error')) {
          $(this).addClass('validate-error')
        }
      } else {
        $(this).removeClass('validate-error')
        if (!$(".form_signup_input.lastname_kata").hasClass('validate-error')) {
          errorMessage.hide();
        }
      }
    }
  });

  $('.form_signup_input.lastname_kata').keyup(function() {
    let lastName = $(this).val();
    let errorMessage = $(this).closest('.form_signup_container ').find('.error-message');
    if (lastName === '') {
        errorMessage.show();
        $(this).addClass('validate-error')
        errorMessage.text('ヨミガナが入力されていません。')
    } else {
      var katakanaRegex = /^[\u30A0-\u30FF]+$/;
      if (!katakanaRegex.test(lastName)) {
        errorMessage.show();
        errorMessage.text('正しくヨミガナを入力してください。')
        if (!$(this).hasClass('validate-error')) {
          $(this).addClass('validate-error')
        }
      } else {
        $(this).removeClass('validate-error')
        if (!$(".form_signup_input.firstname_kata").hasClass('validate-error')) {
          errorMessage.hide();
        }
      }
    }
  });

  $('.form_signup_input.email').keyup(function() {
    let emailValue = $(this).val();
    let errorMessage = $(this).closest('.form_signup_container ').find('.error-message');
    if (emailValue === '') {
        errorMessage.show();
        $(this).addClass('validate-error')
        errorMessage.text('メールアドレスが入力されていません。')
    } else {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailValue)) {
        errorMessage.show();
        errorMessage.text('正しくメールアドレスを入力してください。')
        if (!$(this).hasClass('validate-error')) {
          $(this).addClass('validate-error')
        }
      } else {
        errorMessage.hide();
        $(this).removeClass('validate-error')
      }
    }
  });

  $('.form_signup_input.phone').keyup(function() {
    let phoneValue = $(this).val();
    let errorMessage = $(this).closest('.form_signup_container ').find('.error-message');
    if (phoneValue === '') {
        errorMessage.show();
        $(this).addClass('validate-error')
        errorMessage.text('電話番号が入力されていません。')
    } else {
      var phoneRegex = /^\d{10}$|^\d{11}$/;
      if (!phoneRegex.test(phoneValue)) {
        errorMessage.show();
        errorMessage.text('正しく電話番号を入力してください。')
        if (!$(this).hasClass('validate-error')) {
          $(this).addClass('validate-error')
        }
      } else {
        errorMessage.hide();
        $(this).removeClass('validate-error')
      }
    }
  });

  $('.form_signup_input.datebirth').on('change keyup', function() {
    let content = $(this).val();
    let errorMessage = $(this).closest('.form_signup_container ').find('.error-message');
    if (content === '') {
      errorMessage.show();
      $(this).addClass('validate-error')
      errorMessage.text('生年月日が入力されていません。')
    } else {
      $(this).removeClass('validate-error')
      errorMessage.hide();
    }
  });
});

